import ChangelogStore from './ChangelogStore';
import ErrorStore from './ErrorStore';
import MensagemStore from './MensagemStore';
import AlertStore from './AlertStore';
import UsuarioStore from './UsuarioStore';
import AplicacaoStore from './AplicacaoStore';
import { RouterStore } from 'mobx-react-router';

export const errorStore = new ErrorStore();
export const mensagemStore = new MensagemStore();
export const alertStore = new AlertStore();
export const changelogStore = new ChangelogStore();
export const usuarioStore = new UsuarioStore(JSON.parse(sessionStorage.getItem('SE-UsuarioStore')));
export const routerStore = new RouterStore();
export const aplicacaoStore = new AplicacaoStore();
